import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatChipSelectionChange } from '@angular/material/chips';
import { Subscription } from 'rxjs';
import { FilterMultipleChoiceTags } from '../../../lib/model/Filter';
import { FilterService } from '../../../lib/services/filter.service';

@Component({
  selector: 'app-filter-multiple-choice-tags',
  templateUrl: './filter-multiple-choice-tags.component.html',
  styleUrls: ['./filter-multiple-choice-tags.component.scss'],
})
export class FilterMultipleChoiceTagsComponent implements OnInit, OnDestroy {
  /**
   * Subscription to filter service to auto update the filter upon request.
   */
  private filterServiceSubscription: Subscription;
  /**
   * The filter to initialize the component with.
   */
  @Input() filter: FilterMultipleChoiceTags;
  /**
   * Emit the filter upon update.
   */
  @Output() filterUpdated: EventEmitter<FilterMultipleChoiceTags> = new EventEmitter();

  constructor(private filterService: FilterService) { }

  ngOnInit() {
    this.filterServiceSubscription = this.filterService.filterSubject.subscribe((filter) => {
      if (filter.id === this.filter.id) {
        this.filter = <FilterMultipleChoiceTags>filter;
        this.filterUpdated.emit(this.filter);
      }
    });
  }

  ngOnDestroy() {
    this.filterServiceSubscription.unsubscribe();
  }

  toggleVisibility() {
    this.filter.visible = !this.filter.visible;
  }

  updateSelected(id: string, $event: MatChipSelectionChange) {
    const index: number = this.filter.selected.indexOf(id);
    // If already selected, unselect...
    if (index > -1) {
      this.filter.selected.splice(index, 1);
    } else { // Else select it
      this.filter.selected.push(id);
    }
    this.filterUpdated.emit(this.filter);
  }
}
